import {CyClass} from "../../../../../common/cy-classes";
import {useServices} from "../../../../react-hooks/use-services.hook"
import {withServices} from "../../../../react-hooks/with-services";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {MobileBackLabelBox} from "../../../main-nav/boxes/mobile/back/mobile-back-label.box";
import {MobileBackBox} from "../../../main-nav/boxes/mobile/back/mobile-back.box";
import {MobileMenuHeaderBox} from "../../../main-nav/boxes/mobile/mobile-menu-header.box";
import {UserMenuCloseIconBox} from "../../../user-menu/close-button/boxes/close-icon/user-menu-close-icon.box";
import {ClientSettingsTitleBox} from "./boxes/title/client-settings-title.box"


interface ClientSettingsMobileTitleProps extends ComponentServicesPick<'sideMenu'> {

}


const ComponentBody: React.FC<ClientSettingsMobileTitleProps> = (props) => {
    const services = useServices();

    const closeMobileClientSettings = () => {
        props.sideMenu.closeMobileClientSettings();
    }

    const closeMoblieNavAndSettings = () => {
        props.sideMenu.closeMobileClientSettings();
        props.sideMenu.closeMobileMenu();
    }

    const BackIcon = services.theme.currentTheme.icons.leftArrowIcon;
    const CloseIcon = services.theme.currentTheme.icons.closeIcon;

    return (
        <MobileMenuHeaderBox>
            <MobileBackBox>
                <span onClick={closeMobileClientSettings}><BackIcon /></span>
                <MobileBackLabelBox>{services.translation.translate("BACK")}</MobileBackLabelBox>
            </MobileBackBox>

            <ClientSettingsTitleBox>{services.translation.translate('SETTINGS')}</ClientSettingsTitleBox>

            <UserMenuCloseIconBox
                onClick={closeMoblieNavAndSettings}
                className={CyClass('cy-close-mobile-menu-from-client-settings-icon')}
            ><CloseIcon /></UserMenuCloseIconBox>
        </MobileMenuHeaderBox >
    )
}

export const ClientSettingsMobileTitleComponent = withServices(ComponentBody, ['sideMenu']);